<template>
  <footer class="bg-mask">
    <section class="layout-container">
      <div class="row footer-top">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 about">
          <div class="about-title">
            <app-i18n code="saryahLanding.footer.about"></app-i18n>
          </div>

          <div class="flex no-wrap">
            <div class="one-side-border"></div>
            <div class="about-content">
              <app-i18n code="saryahLanding.footer.aboutContent"></app-i18n>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 contact-us">
          <div class="contact-us-title">
            <app-i18n code="saryahLanding.footer.contactUs"></app-i18n>
          </div>

          <div class="flex no-wrap">
            <div class="one-side-border" v-if="!is_screen_sm || !is_screen_xs"></div>
            <div class="contact-us-content">
              <div class="mail">
                <q-icon name="img:/images/auth/ic-mail.svg" size="2rem"></q-icon>
                <app-i18n code="saryahLanding.footer.mail" style="vertical-align: middle;"></app-i18n>
              </div>

              <div class="location">
                <q-icon name="img:/images/auth/ic-pin.svg" size="2rem"></q-icon>
                <app-i18n code="saryahLanding.footer.location" style="vertical-align: middle;"></app-i18n>
              </div>
            </div>
          </div>

          <div class="contact-us-link">
            <router-link :to="{ path:'/privacy-policy'}" target="_blank" style="color: #FFFFFF;">
              <app-i18n code="common.privacyPolicy"></app-i18n>
            </router-link>

            <router-link :to="{ path:'/terms-and-conditions'}" target="_blank" style="color: #FFFFFF;">
              <app-i18n code="common.termsAndConditions"></app-i18n>
            </router-link>
          </div>
        </div>
      </div>

      <div class="row justify-between items-center footer__copyrights">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 q-px-none"
          :class="{ 'flex justify-center q-pb-lg': is_screen_xs}">
          <app-i18n code="saryahLanding.footer.copyRight"></app-i18n>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 q-px-none flex justify-center">
          <a href="https://www.facebook.com/" target="_blank">
            <q-icon name="fab fa-facebook-f" size="1.5rem"></q-icon>
          </a>
          <a href="https://twitter.com/" target="_blank">
            <q-icon name="fab fa-twitter" size="1.5rem"></q-icon>
          </a>
          <a href="https://www.linkedin.com/" target="_blank">
            <q-icon name="fab fa-linkedin-in" size="1.5rem"></q-icon>
          </a>
        </div>
      </div>

    </section>
  </footer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { i18n } from '@/i18n';

export default {
  name: 'app-auth-footer',

  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
      menuCollapsed: 'layout/menuCollapsed',
      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
    }),
    mobileBreakpoint() {
      return this.is_screen_sm || this.is_screen_xs
    }
  },
  methods: {
    ...mapActions({

    }),
    i18n(key, args) {
      return i18n(key, args);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-top {
  padding-top: 47px !important;
  padding-bottom: 54px !important;
}

.bg-mask {
  background-image: url('/images/auth/auth-footer.webp') !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

.about {
  padding-left: 0 !important;
  padding-right: 73px !important;

  .about-title {
    font-style: normal !important;
    font-weight: bold !important;
    font-size: 30px !important;
    line-height: 45px !important;
    display: flex !important;
    align-items: center !important;
    color: #FFFFFF !important;
    text-transform: uppercase !important;
    margin-bottom: 24px !important;
  }

  .about-content {
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 20px !important;
    line-height: 30px !important;
    text-align: justify !important;
    color: #FFFFFF !important;
    opacity: 0.8 !important;
  }
}

.contact-us {
  padding-left: 73px !important;
  padding-right: 0 !important;

  .contact-us-title {
    font-style: normal !important;
    font-weight: bold !important;
    font-size: 30px !important;
    line-height: 45px !important;
    display: flex !important;
    align-items: center !important;
    text-transform: uppercase !important;
    color: #FFFFFF !important;
    margin-bottom: 24px !important;
  }

  .contact-us-content {
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 20px !important;
    line-height: 30px !important;
    color: #FFFFFF !important;

    .q-icon {
      margin-right: 1.5rem !important;
    }

    .mail {
      margin-bottom: 30px !important;
    }
  }

  .contact-us-link {
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 20px !important;
    line-height: 22px !important;
    color: #FFFFFF !important;
    padding-top: 63px !important;
    padding-left: 21px !important;

    & a:first-child {
      padding-right: 41px !important;
    }
  }
}

.one-side-border {
  width: 5px !important;
  background: #da3b30 !important;
  opacity: 1 !important;
  border-top-right-radius: 50px !important;
  border-bottom-right-radius: 50px !important;
  margin-right: 28px !important;
}

.footer__copyrights {
  display: flex !important;
  justify-content: space-between !important;
  color: #FFFFFF !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 1rem !important;
  line-height: 18px !important;
  padding-bottom: 36px !important;

  a {
    color: #FFFFFF !important;
    padding: 0 1.25rem !important
  }

  a:hover {
    color: #da3b30 !important
  }
}

.footer__copyrights-xs {
  color: #FFFFFF !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  line-height: 30px !important;
  padding: 1em 0 !important;
  text-align: center !important;
}
</style>

<style lang="scss" scoped>
@media (max-width: 1440px) {
  .footer-top {
    padding-top: calc(30px + (47 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
    padding-bottom: calc(30px + (54 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .about {
    padding-right: calc(50px + (73 - 50) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .contact-us {
    padding-left: calc(50px + (73 - 50) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .about .about-title,
  .contact-us .contact-us-title {
    font-size: calc(18px + (30 - 18) * ((100vw - 320px) / (1440 - 320))) !important;
    line-height: calc(30px + (45 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
    margin-bottom: calc(10px + (24 - 10) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .about .about-content,
  .contact-us .contact-us-content {
    font-size: calc(16px + (20 - 16) * ((100vw - 320px) / (1440 - 320))) !important;
    line-height: calc(25px + (30 - 25) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .contact-us .contact-us-content .mail {
    margin-bottom: calc(20px + (30 - 20) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .contact-us .contact-us-link {
    font-size: calc(14px + (20 - 14) * ((100vw - 320px) / (1440 - 320))) !important;
    line-height: 22px !important;
    padding-top: calc(40px + (63 - 40) * ((100vw - 320px) / (1440 - 320))) !important;

    & a:first-child {
      padding-right: calc(20px + (41 - 20) * ((100vw - 320px) / (1440 - 320))) !important;
    }
  }
}

@media (max-width: 1023px) {
  .about {
    padding: 0 !important;
    margin-bottom: 2.5rem;

    .about-title {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .about-content {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      text-align: center !important;
    }
  }

  .contact-us {
    padding: 0 !important;

    .contact-us-title {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .contact-us-content {
      text-align: center !important;
    }

    .contact-us-link {
      text-align: center !important;
      padding-left: 0 !important;
    }
  }

  .one-side-border {
    display: none !important;
  }
}
</style>

